import {prober as getProber, captureWarning} from '@base/app-services/prober'
import {uuid} from '@base/utils/uuid'

import {createSpanContext} from '../datadogId'

export default class ProberEvent {
  data: any = {}
  safeData: any = {}
  type: string | undefined | null

  constructor(data?: any) {
    if (data) {
      this.addData(data)
    }

    this.addData({
      timestamp: new Date().getTime(),
      millis: performance.now(),
      interactionId: this.data.interactionId || uuid(),
      spanContext: this.data.spanContext || createSpanContext(),
    })

    this.addData(getProber().getDefaultEventData())
  }

  addData(data: any) {
    const {type, ...dataToAdd} = data || {}

    if (type) {
      // Note: The "type" key has special meaning for prober's backends (it is set in the
      // constructor) so we want to prevent from overriding this value unintentionally
      // See https://getbase.atlassian.net/browse/FNDP-2650
      const msg = `Attempt to override "type" of ${
        this.constructor.name
      } with ${String(type)}`
      if (DEVELOPMENT || TESTING) {
        throw new Error(
          `${msg} likely because the code uses "type" meta in captureAction`
        )
      } else {
        // TODO remove captureWarning when all "type" occurrences are fixed
        captureWarning('ProberEvent - overriding type', msg)
      }
    }

    this.data = {type: 'unknown', ...this.data, ...dataToAdd}
    return this
  }

  getData(): any {
    return this.data
  }
  getSafeData() {
    return {...this.getData(), ...this.safeData}
  }

  getType() {
    return this.data.type || this.type
  }

  getInteractionName() {
    return this.data.type
  }

  getInteractionId() {
    return this.data.interactionId
  }

  getChildInteractionData() {
    return {
      parentInteractionId: this.data.interactionId,
      parentInteractions: `${
        this.data.parentInteractions || ''
      }/${this.getInteractionName()}`,
    }
  }

  getTimeStamp() {
    return this.data.timestamp
  }

  getAccurateTimestamp() {
    return this.data.millis
  }

  offsetTimestamp(offset: number) {
    const ms = Math.round(offset)
    this.data.timestamp += ms
    this.data.millis += ms
  }
}

export type ProberEventType = ProberEvent
